export default "__VITE_ASSET__DAwpqYbc__"